import React, { useEffect, useState } from 'react';
import DataTable from '../../../components_shared/DataTable';
import api, { dispatchAPI, apiBaseUrl } from '../../../utils/api';

export default function IncomingShipmentsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const res = await api.get('/api/v1/inventory/dispatch-notes', { params:{ page:0, size:50, sort:'id,desc'} });
      const filtered = (res.data.content||[]).filter(d => d.status==='ARRIVED_GATE' || d.status==='DISPATCHED');
      setRows(filtered);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{ fetchData(); },[]);

  const columns = [
    { header: 'Ref #', cell: ({ row }) => row.original.referenceNo || row.original.reference_no },
    { header: 'Work Order', cell: ({ row }) => row.original.workOrderNo || row.original.work_order_no },
    { accessorKey: 'quantity', header: 'Qty' },
    { header: 'Truck #', cell: ({ row }) => row.original.truckNumber || row.original.truck_number },
    { accessorKey: 'eta', header: 'ETA' },
    { accessorKey: 'status', header: 'Status' },
    { id:'pdf',header:'Receipts',cell:({row})=>{
        const st=row.original.status;
        const id=row.original.id;
        if(st==='DISPATCHED') return <button className="btn btn-outline-primary btn-sm" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/dispatch-notes/${id}/pdf`,'_blank')}>📄 Dispatch Note</button>;
        if(st==='ARRIVED_GATE' || st==='IN_QC') return <button className="btn btn-outline-secondary btn-sm" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/provisional-receipts/${id}/pdf`,'_blank')}>📄 Provisional</button>;
        if(st==='RECEIVED_FINAL') return <button className="btn btn-outline-success btn-sm" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/final-receipts/${id}/pdf`,'_blank')}>📄 Final</button>;
        return null;}
    },
    { id:'scan', header:'Gate', cell:({row})=> (
        <button className="btn btn-secondary btn-sm" onClick={async()=>{
          try{ await dispatchAPI.gateScan(row.original.id,null); fetchData(); }
          catch(e){ alert(e.response?.data?.message||e.message);} }}>
          Gate Scan
        </button>
      )},
    { id:'prov', header:'Provisional', cell:({row})=> (
        <button className="btn btn-primary btn-sm" disabled={row.original.status!=='ARRIVED_GATE'} onClick={async()=>{
          try{ await dispatchAPI.provisional(row.original.id); fetchData(); }
          catch(e){ alert(e.response?.data?.message||e.message);} }}>
          Provisional
        </button>
      )},
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="inventory-page">
      <div className="premium-card inventory-page-card">
        <h2>Incoming Shipments</h2>
        <DataTable data={rows} columns={columns} />
      </div>
    </div>
  );
}
